import { render, staticRenderFns } from "./delivery-tab-layout.vue?vue&type=template&id=549a145a&"
import script from "./delivery-tab-layout.vue?vue&type=script&lang=js&"
export * from "./delivery-tab-layout.vue?vue&type=script&lang=js&"
import style0 from "./delivery-tab-layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('549a145a')) {
      api.createRecord('549a145a', component.options)
    } else {
      api.reload('549a145a', component.options)
    }
    module.hot.accept("./delivery-tab-layout.vue?vue&type=template&id=549a145a&", function () {
      api.rerender('549a145a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/delivery-selector/delivery-tab-layout.vue"
export default component.exports